import {
    VaccinationData,
    IntervalWithOrganizationQuery,
    IntervalWithAuthorQuery,
    UnpaidRenderedServiceResponse,
    UnpaidRenderedServiceData,
    FindEntryWithoutRenderedServiceResponse,
    UnansweredReferralsForAuthorData,
    UnansweredAuthorReferralsResponse,
    UnansweredDoctorReferralData,
    UnansweredDoctorReferralResponse,
    FindErrorRenderedServiceResponse,
    ErrorRenderedServiceData,
    UnpaidReferralRenderedServiceData,
    UnpaidReferralRenderedServiceResponse,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/bi';

export class BiApi {
    public static async getUnpaidRenderedService(
        params: IntervalWithOrganizationQuery,
    ): Promise<UnpaidRenderedServiceData[]> {
        const res = await axios.get<UnpaidRenderedServiceResponse>(`${BASE_URL}/unpaid-rendered-service`, { params });
        return res.data.unpaidRenderedServices;
    }

    public static async getUnpaidReferralRenderedService(params: {
        referralAuthorId?: string;
    }): Promise<UnpaidReferralRenderedServiceData[]> {
        const res = await axios.get<UnpaidReferralRenderedServiceResponse>(
            `${BASE_URL}/unpaid-referral-rendered-service`,
            { params },
        );
        return res.data.unpaidReferralRenderedServices;
    }

    public static async getVaccination(params: IntervalWithOrganizationQuery): Promise<VaccinationData[]> {
        const res = await axios.get(`${BASE_URL}/vaccination`, { params });
        return res.data.vaccination;
    }

    public static async findEntryWithoutRenderedService(
        params: IntervalWithAuthorQuery,
    ): Promise<FindEntryWithoutRenderedServiceResponse> {
        const res = await axios.get<FindEntryWithoutRenderedServiceResponse>(
            `${BASE_URL}/entry-without-rendered-service`,
            { params },
        );

        return res.data;
    }

    public static async findUnansweredReferralsForAuthor(
        params: IntervalWithAuthorQuery,
    ): Promise<UnansweredReferralsForAuthorData[]> {
        const res = await axios.get<UnansweredAuthorReferralsResponse>(`${BASE_URL}/unanswered-author-referral`, {
            params,
        });
        return res.data.referrals;
    }

    public static async findUnansweredReferralsForDoctor(
        params: IntervalWithAuthorQuery,
    ): Promise<UnansweredDoctorReferralData[]> {
        const res = await axios.get<UnansweredDoctorReferralResponse>(`${BASE_URL}/unanswered-doctor-referral`, {
            params,
        });
        return res.data.referrals;
    }

    public static async findErrorRenderedServices(): Promise<ErrorRenderedServiceData[]> {
        const res = await axios.get<FindErrorRenderedServiceResponse>(`${BASE_URL}/error-rendered-services`);
        return res.data.renderedServices;
    }
}
